module.exports = __webpack_public_path__ + "static/media/page-header-bg.9935be68.png";